import React from 'react';
import './TrafficSources.css';

const TrafficSources = ({ sources, isLoading }) => {
  const getChannelColor = (channel) => {
    switch (channel) {
      case 'Organic Search': return '#2E7D4F';
      case 'Direct': return '#3b82f6';
      case 'Organic Social': return '#ec4899';
      case 'Referral': return '#f59e0b';
      case 'Email': return '#8b5cf6';
      default: return '#9ca3af';
    }
  };

  if (isLoading) {
    return (
      <div className="ga-traffic-card">
        <div className="ga-traffic-title">Traffic sources</div>
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="ga-traffic-item">
            <div className="ga-traffic-row">
              <div className="ga-skeleton" style={{ width: '100px', height: '14px' }}></div>
              <div className="ga-skeleton" style={{ width: '40px', height: '14px' }}></div>
            </div>
            <div className="ga-traffic-bar-bg">
              <div className="ga-skeleton" style={{ width: '60%', height: '6px', borderRadius: '99px' }}></div>
            </div>
            <div className="ga-skeleton" style={{ width: '80px', height: '12px', marginTop: '4px' }}></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="ga-traffic-card">
      <div className="ga-traffic-title">Traffic sources</div>
      
      {sources.map((source, index) => (
        <div key={index} className="ga-traffic-item">
          <div className="ga-traffic-row">
            <div className="ga-traffic-channel">{source.channel}</div>
            <div className="ga-traffic-pct">{source.percentage}%</div>
          </div>
          
          <div className="ga-traffic-bar-bg">
            <div 
              className="ga-traffic-bar-fill"
              style={{ 
                width: `${source.percentage}%`,
                background: getChannelColor(source.channel)
              }}
            ></div>
          </div>
          
          <div className="ga-traffic-sessions">
            {source.sessions.toLocaleString()} sessions
          </div>
        </div>
      ))}
      
      {sources.length === 0 && !isLoading && (
        <div style={{ textAlign: 'center', color: 'var(--ga-muted)', fontSize: '0.875rem', padding: '2rem 0' }}>
          No traffic data available
        </div>
      )}
    </div>
  );
};

export default TrafficSources;